import { inject, Injectable } from '@angular/core';
import { ILayout } from '../cockpitDesigner/cockpitDesigner.models';
import { catchError, firstValueFrom, map, Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Device } from '../bots/bots.component';

type DeviceLayoutResponse = {
  layout: {
    layout:{
      data:{
        dataJSON:ILayout
      }
    }
  }
  device: Device
};

@Injectable({
  providedIn: 'root',
})
export class CockpitApi {
  private http = inject(HttpClient);

  fetchLayoutById(id: string): Observable<ILayout | null> {
    return this.http
      .get<{
        layout: {
          data: { dataJSON: ILayout };
        };
        assignedDevices: string[];
      }>(`/api/devices/layout/${id}`)
      .pipe(
        map((response) => response.layout.data.dataJSON),
        catchError(() => of(null)),
      );
  }



  fetchDeviceById(id: string) {
    return this.http.get<DeviceLayoutResponse>(`/api/devices/${id}`);
  }
}
